(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@aws-amplify/core"));
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_cache", ["@aws-amplify/core"], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_cache"] = factory(require("@aws-amplify/core"));
	else
		root["aws_amplify_cache"] = factory(root["@aws-amplify/core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 